import React from 'react';

const SelectUnit = ({ id, drawing, unit, setUnit }) => {
  const onChange = (e) => {
    setUnit(() => e.target.value);
  };

  return (
    <div className="row mb-6" data-widget-element="form-group">
      <div className="input-group mb-3">
        <span className="input-group-text font13" id="basic-addon3" data-widget-element="label">
          {t('my_drawings.options_unit_short')}
        </span>

        <select
          className="form-select form-control text-align-right"
          onChange={onChange}
          value={unit}
          data-widget-element="select"
        >
          <option value="in">{t('drawing.unit_in')}</option>
          <option value="mm">{t('drawing.unit_mm')}</option>
        </select>
      </div>
    </div>
  );
};

export default SelectUnit;
